module.exports = __webpack_public_path__ + "static/CorprateHp_07-a8e9f59768fdd450167d2e969e8b300d.jpg";